<template>
  <div class="EnrollmentManage EnrollmentManage-importAdmission">
    <PageNav>
      <div id="admissionCue-importAdmission" class="height100">
        <div class="head-tab--nav">
          <div class="head-nav h-3">
            <span class="c-normal">{{
              $t("ListAllocationManagement.ao")
            }}</span>
          </div>
        </div>
        <div class="content-box bg-white flex1">
          <div class="step">
            <el-steps
              :space="200"
              :active="1"
              class="steps-pop"
              finish-status="success"
              align-center
            >
              <el-step :title="$t('Admissioncue.cq')"></el-step>
              <el-step :title="$t('ListAllocationManagement.ap')"></el-step>
              <el-step :title="$t('Admissioncue.cs')"></el-step>
            </el-steps>
          </div>
          <div class="importlist">
            <div class="single-list">
              <el-upload
                class="upload-demo"
                drag
                :action="$uploadAction('/Uploading/File')"
                name="ossfile"
                :show-file-list="false"
                :on-progress="uploadFileProcess"
                :on-success="handleAvatarSuccess"
                :data="UploadFile"
              >
                <i v-if="one_fileurl == ''" class="mh-wjj icon-wjj"></i>
                <i v-else class="mh-oa_excel"></i>
                <div class="el-upload__text">
                  <template v-if="one_fileurl == ''">
                    {{ $t("Admissioncue.ct") }}
                    <em style="color: #0ea8f7">{{ $t("Admissioncue.cu") }}</em>
                  </template>
                  <template v-else>{{ one_fileurl }}</template>
                  <div class="title">
                    {{ $t("ListAllocationManagement.ao") }}
                  </div>
                </div>
                <div class="icon el-upload__tip" slot="tip">
                  <span @click="clickDownload()">{{
                    $t("ListAllocationManagement.aq")
                  }}</span>
                </div>
              </el-upload>
            </div>
          </div>
          <div class="explain">
            <div class="title">{{ $t("Admissioncue.cw") }}</div>
            <div class="article">
              <p>{{ $t("Admissioncue.csl") }}</p>
              <p>{{ $t("Admissioncue.cy") }}</p>
            </div>
          </div>
        </div>
        <!-- 遮罩层 -->
        <div class="layer" v-if="showProcess">
          <div class="layer-cont">
            <el-progress
              :text-inside="false"
              :stroke-width="38"
              :percentage="percentageNum"
            ></el-progress>
            <span class="uploading"
              >{{ $t("Admissioncue.cz") }}{{ percentageNum }}%）</span
            >
          </div>
          <div class="wait-explain mt20 fs14 color-white tc">
            {{ $t("Admissioncue.da") }}
          </div>
        </div>
      </div>
    </PageNav>
  </div>
</template>

<script>
import PageNav from "@/components/Nav/nav";
import storeAdmissionCue from "@/views/Admissioncue/admissionCue.js";
import http from "@/views/Crmactivemanage/crmActiveManage.js";
export default {
  name: "admissionCue-importAdmission",
  data() {
    return {
      showProcess: false, //是否显示进度条
      percentageNum: 20, //进度
      // 文件上传
      one_fileurl: "",
      // 招生有效名单导入名单上传
      UploadFile: {
        ossfile: "",
        company_id: this.$store.state.COMPANY_ID,
      },
    };
  },
  components: {
    PageNav,
  },
  updated() {},
  created() {
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
  },
  computed: {},
  methods: {
    //招生管理->下载招生有效名单导入模版
    getTmkImportTrackApi() {
      http
        .getTmkImportTrackApi({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
        })
        .then((res) => {
          if (res.data.code === 200) {
            const downloadUrl = res.data.data.value || res.data.data.url || "";
            if (downloadUrl) {
              window.open(downloadUrl, "_blank");
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    // 点击下载模板
    clickDownload(type) {
      this.getTmkImportTrackApi();
    },
    //招生有效名单导入名单上传******文件上传过程中的函数(在这里获取进度条的进度)
    uploadFileProcess(event, file, fileList) {
      this.showProcess = true;
      this.percentageNum = Math.floor(event.percent)
        ? parseInt(Math.floor(event.percent))
        : 0;
    },
    // 招生有效名单导入名单上传
    handleAvatarSuccess(res) {
      if (res.code === 200) {
        (() => {})(res);
        this.one_fileurl = res.data.file_url;
        this.showProcess = false;
        // upload_type:0,//0是招生有效名单，1是批量活动
        this.$router.push({
          path: `/ListAllocationManagement/importGrossList?file=${encodeURI(
            this.one_fileurl
          )}`,
        });
      }
    },
  },
  mounted() {},
};
</script>
<style lang="less">
@import url("../../assets/less/enrollmentManage.less");
.EnrollmentManage-importAdmission {
  height: 100vh;
  font-size: 20px;
  #admissionCue-importAdmission {
    .flex-line {
      border-bottom: 10px solid #f6f9fc;
    }
    .content-box {
      margin: 20px 20px 0px 20px;
      border: 1px solid #ddd;
      padding: 20px;
    }
    //遮罩层
    .layer {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1;
      margin: auto;
      background: rgba(0, 0, 0, 0.5);
      .el-progress {
        width: 570px;
        height: 38px;
        margin: 20% auto 0 auto;
        .el-progress-bar {
          padding-right: 0px;
          .el-progress-bar__outer {
            height: 38px !important;
          }
        }
      }
      .el-progress__text {
        display: none;
      }
      .layer-cont {
        position: relative;
        .uploading {
          color: #333333;
          font-size: 18px;
          position: absolute;
          top: 20%;
          left: 47%;
        }
      }
    }

    .step {
      margin: 20px 0 50px 0;
    }
    .importlist {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      padding-left: 7.5%;
      > div {
        width: 42.5%;
        max-width: 668px;
      }
      .el-upload {
        width: 100%;
        .el-upload-dragger {
          width: 100%;
          height: 361px;
          background: #fff;
          i {
            font-size: 84px;
            display: inline-block;
            margin: 110px 0 16px 0;
          }
          .icon-wjj::before {
            color: #dddddd;
          }
          .el-upload__text {
            .title {
              position: absolute;
              top: 20px;
              left: 20px;
              color: #333333;
            }
          }
        }
      }
      .el-upload__tip > span {
        color: #0ea8f7;
        cursor: pointer;
      }
    }
    .explain {
      font-size: 14px;
      margin: 39px 0 20px 7.5%;
      .title {
        color: #aaaaaa;
        margin-bottom: 7px;
      }
    }
  }
}
</style>
